// Signing in where it is asked for: the aldoo-ra sign-in dialog opens over
// the page the visitor is on, and after it they are still there (or, given
// `redirect`, go there). The /sign-in page is for when it is opened on
// purpose — a link, a bookmark — and keeps its own rules (a merchant goes to
// the portal).
import { useEffect, useRef } from "react"
import PubSub from "pubsub-js"
import { navigate } from "vike/client/router"

/** The sign-in dialog, over this page. */
export function requestSignIn(redirect) {
  PubSub.publish("signin", redirect ? { redirect } : {})
}

/**
 * A page that needs an account: for a guest the dialog opens over it; closed
 * without signing in, the visitor goes to `fallback` (the home page unless
 * said), instead of staying on a page that has nothing to show them.
 */
export function useSignInGate(auth, fallback = "/") {
  const asked = useRef(false)
  const fallbackRef = useRef(fallback)
  fallbackRef.current = fallback
  useEffect(() => {
    if (auth !== null || asked.current) return
    asked.current = true
    const timer = setTimeout(() => requestSignIn(), 200)
    const token = PubSub.subscribe("signin-closed", () => {
      const target = fallbackRef.current
      if (typeof target === "function") target()
      else navigate(target || "/")
    })
    return () => {
      clearTimeout(timer)
      PubSub.unsubscribe(token)
    }
  }, [auth])
  useEffect(() => {
    if (auth) asked.current = false
  }, [auth])
}
